export default __webpack_public_path__ + "static/media/viv_kombucha.0846f77b.jpg";